import React from "react";

const departments = [
  { id: "ECE", name: "Electronics and Communication Engineering" },
  // { id: "CSE", name: "Computer Science Engineering" },
  // { id: "ME", name: "Mechanical Engineering" },
  // { id: "CE", name: "Civil Engineering" },
  // { id: "EEE", name: "Electrical and Electronics Engineering" },
];

const DepartmentSelector = ({ selectedDepartment, onChange }) => {
  return (
    <div className="mb-6">
      <label
        htmlFor="department"
        className="block text-sm font-medium text-gray-700 mb-2"
      >
        Department
      </label>
      <select
        id="department"
        name="department"
        value={selectedDepartment}
        onChange={(e) => onChange(e.target.value)}
        className="block w-full pl-3 pr-10 py-2 text-base border border-gray-300 rounded-md shadow-sm bg-white text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#800000] focus:border-[#800000] hover:border-gray-400 transition-colors sm:text-sm"
      >
        {departments.map((dept, index) => (
          <option
            key={dept.id || index}
            value={dept.id}
            disabled={dept.id === ""} // Disable placeholder
          >
            {dept.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DepartmentSelector;
